import React from 'react';
import { Text as RechartText, TextProps } from 'recharts';

type CustomizedAxisTickProps = Omit<TextProps, 'ref'> & {
  payload?: { value: string };
  nodesLength: number;
};

export const CustomizedAxisTick: React.FC<CustomizedAxisTickProps> = ({
  payload,
  nodesLength,
  ...props
}) => {
  return (
    <RechartText {...props}>
      {payload?.value.length &&
      payload?.value.length > (nodesLength > 10 ? 4 : 10) &&
      nodesLength > 3
        ? `${payload?.value.slice(0, nodesLength > 10 ? 4 : 10)}...`
        : payload?.value}
    </RechartText>
  );
};
